import {
  initAlpine
} from "./init";

import Lenis from 'lenis';

import gsap from 'gsap';

import {
  ScrollTrigger
} from "gsap/ScrollTrigger";

import {
  ScrollToPlugin
} from "gsap/ScrollToPlugin";

import {
  CustomEase
} from "gsap/CustomEase";

import {
  SplitText
} from 'gsap/SplitText';

import Splide from '@splidejs/splide';



// GSAP plugins register and custom easing

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, CustomEase, SplitText);




ScrollTrigger.config({

  limitCallbacks: true,

  ignoreMobileResize: true, // Blokuje odświeżanie przy zmianie paska adresu

  autoRefreshEvents: "load,visibilitychange" // WYWALILIŚMY 'resize' stąd

});



// Zapobiega zapamiętywaniu błędnej pozycji scrolla przez przeglądarkę

if ('scrollRestoration' in history) {

  history.scrollRestoration = 'manual';

}




function customGsapEasing() {

  CustomEase.create('loader', '0.83, 0, 0.17, 1');

  CustomEase.create('loader2', '0.77, 0, 0.175, 1');

}



// Functions definitions



// Contact form open animation

let contactFormOpen;




// --- SEKCJA NAPRAWCZA I OPTYMALIZACYJNA ---



// Bezpiecznik dla Video (Safari Safety)

const originalPlay = HTMLVideoElement.prototype.play;

HTMLVideoElement.prototype.play = function() {

  const promise = originalPlay.apply(this, arguments);

  if (promise !== undefined) {

    promise.catch(() => {}); // Cichy catch, żeby nie przerywać skryptów

  }

  return promise;

};



const isMobile = window.innerWidth < 992;



let lenis;



if (!isMobile) {

  // PEŁNY LENIS DLA DESKTOP (Zoptymalizowany pod płynność)

  lenis = new Lenis({

    lerp: 0.1, // Lżejszy niż easing, eliminuje szatkowanie

    wheelMultiplier: 1,

    smoothWheel: true,

  });

} else {

  // PEŁNY MOCK DLA MOBILE (Zawiera wszystkie metody, których szukają Twoje funkcje)

  lenis = {

    start: () => {},

    stop: () => {},

    scrollTo: (target, options) => {

      let offset = 0;

      if (typeof target === 'number') offset = target;

      else if (target instanceof HTMLElement) offset = target.offsetTop;

      else if (typeof target === 'string') {

        const el = document.querySelector(target);

        if (el) offset = el.offsetTop;

      }

      window.scrollTo({
        top: offset,
        behavior: options?.immediate ? 'auto' : 'smooth'
      });

    },

    raf: () => {},

    on: () => {},

    off: () => {},

    destroy: () => {},

    scroll: 0,

    actualScroll: 0,

    velocity: 0,

    direction: 0,

    progress: 0,

    isScrolling: false,

    options: {}

  };

}



// Globalne ustawienia ScrollTriggera dla wydajności

ScrollTrigger.config({

  limitCallbacks: true,

  ignoreMobileResize: true

});



function lenisScroll() {

  if (isMobile) return;



  // Rezygnujemy ze scrollerProxy (to ono zamulało przy maskach)

  // GSAP 3.11+ świetnie radzi sobie z Lenisem bez proxy



  lenis.on('scroll', ScrollTrigger.update);



  gsap.ticker.add((time) => {

    lenis.raf(time * 1000);

  });



  // USUŃ lagSmoothing(0) - pozwól GSAPowi zarządzać klatkami przy ciężkich maskach

  // gsap.ticker.lagSmoothing(0);

}




function refreshScrollTriggersAfterLoad() {

  window.addEventListener('load', () => {

    setTimeout(() => {

      ScrollTrigger.refresh();

    }, 100); // bufor na przypadkowe opóźnienia, możesz zwiększyć

  });

}




function contactFormOpenAnimation() {

  const contactFormWrapper = document.querySelector('.contact-modal_main-wrapper');

  const contactForm = document.querySelector('.contact-modal_content-wrapper');

  contactFormOpen = gsap.timeline({
    paused: true
  });

  contactFormOpen.to(contactFormWrapper, {

    autoAlpha: 1,

    duration: 0.3,

    ease: 'loader2',

  });

  contactFormOpen.from(contactForm, {

    x: '100%',

    duration: 0.4,

    ease: 'loader2',

  }, '-=0.2');



  // Nested function to handle project category clicks

  function handleProjectCategoryClick() {

    // Find all elements with [project-category]

    const projectCategoryElements = document.querySelectorAll('[project-category]');



    // Add click event listener to each [project-category] element

    projectCategoryElements.forEach(projectCategoryElement => {

      projectCategoryElement.addEventListener('click', () => {

        const projectCategoryValue = projectCategoryElement.textContent.trim().toLowerCase(); // Convert to lowercase



        // Find the matching checkbox element with data-name attribute (case insensitive)

        const checkboxElement = document.querySelector(`.contact-modal_main-wrapper input[type="checkbox"][data-name="${projectCategoryValue}"]`);



        if (checkboxElement) {

          checkboxElement.click(); // Click on the checkbox element

        }

      });

    });

  }



  // Call the function to initialize handling of project category clicks

  handleProjectCategoryClick();

}



function openContactFormFromURL() {

  if (window.location.search.includes('contact') && contactFormOpen) {

    contactFormOpen.play();

  }

}




// Lazy load videos

function lazyLoadVideos() {

  let lazyVideos = [].slice.call(document.querySelectorAll("video.lazyload"));

  if ("IntersectionObserver" in window) {

    let lazyVideoObserver = new IntersectionObserver(function(entries, observer) {

      entries.forEach(function(video) {

        if (video.isIntersecting) {

          for (let source of video.target.children) {

            source.setAttribute("src", source.getAttribute("data-src"));

          }

          video.target.load();

          video.target.play();

          lazyVideoObserver.unobserve(video.target);

        }

      });

    });

    lazyVideos.forEach(function(lazyVideo) {

      lazyVideoObserver.observe(lazyVideo);

    });

  }

}



// Reload page on browser back action

function reloadOnBack() {

  window.addEventListener('pageshow', function(event) {

    if (event.persisted) {

      window.location.reload();

    }

  });

}



// Scroll disable when mobile menu opened

function disableScrollMenu() {

  function observeNavOverlay() {

    const target = document.querySelector('.w-nav-overlay');

    const config = {
      attributes: true,
      attributeFilter: ['style']
    };

    const callback = function(mutationsList, observer) {

      for (const mutation of mutationsList) {

        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {

          const displayValue = target.style.display;

          if (displayValue === 'none') {

            document.body.classList.remove('is-scroll-off');

            lenis.start();

          } else {

            document.body.classList.add('is-scroll-off');

            lenis.stop();

          }

        }

      }

    };

    const observer = new MutationObserver(callback);

    observer.observe(target, config);

  }

  observeNavOverlay();

}



function revealFooter() {

  const footer = document.querySelector('.is-footer');

  const hero = document.querySelector('#heroSection') || document.querySelector('#heroSectionCs');



  if (footer && hero) {

    gsap.to(hero, {

      scrollTrigger: {

        trigger: '#bottomWrapper',

        start: 'top bottom',

        toggleActions: 'restart none none reverse',

      },

      autoAlpha: 0,

    });

  }

}




// Check if element exists in DOM

function checkElementExists(selector) {

  const element = document.querySelector(selector);

  if (!element) {

    return false;

  }

  return true;

}




function initStickyNavbarAnimation() {

  const stickyBar = document.querySelector('[sticky-bar]');

  if (!stickyBar) return;



  let mm = gsap.matchMedia();



  // Reaguje tylko na szerokość okna od 768px w górę

  mm.add("(min-width: 768px)", () => {



    gsap.to('.button_small.is-navbar', {

      y: '1.5rem',

      duration: 0.4,

      ease: 'power2.out',

      scrollTrigger: {

        trigger: stickyBar,

        start: 'top top',

        end: 'max',

        toggleActions: 'play reverse none reverse',

      }

    });




  });

}



function initBasicAnimations() {

  // iPhone Fix: Czyścimy wszystko co mogło zostać po lockScroll

  document.body.style.cssText = '';

  document.documentElement.style.cssText = '';



  window.isPageUnlocked = true;



  // Dajemy przeglądarce 100ms na ogarnięcie layoutu zanim stworzymy triggery

  setTimeout(() => {

    gsapTitleAnimation();

    gsapContainerAnimation();

    gsapFadeAnimation();



    if (!isMobile && typeof lenis !== 'undefined') {

      lenis.start();

    }

    ScrollTrigger.refresh(true);

  }, 100);

}




function pageLoadAnimation() {



  // Check if all required loader elements exist

  const requiredElements = [

    '.loader_ract.is-left',

    '.loader_ract.is-right',

    '.loader_wrapper'

  ];



  const allElementsExist = requiredElements.every(selector => checkElementExists(selector));



  if (!allElementsExist) {

    console.warn('Loader elements not found - skipping loader animation');

    initBasicAnimations();

    return;

  }



  const loaderAnimationIn = gsap.timeline({});



  loaderAnimationIn

    .add(function() {

      history.scrollRestoration = 'manual';



      // Safari-safe scroll to top

      if (typeof lenis !== 'undefined' && lenis.scrollTo) {

        try {

          lenis.scrollTo(0, {
            immediate: true
          });

        } catch (e) {

          window.scrollTo(0, 0);

        }

      } else {

        window.scrollTo(0, 0);

      }

    })

    .to(

      '.loader_ract.is-left',

      {

        delay: 0.2,

        duration: 0.7,

        x: '100%',

        ease: 'loader2',

      },

      '>'

    )

    .to(

      '.loader_ract.is-right',

      {

        duration: 0.7,

        x: '-100%',

        ease: 'loader2',

      },

      '<'

    )

    .add(function() {

      if (typeof lenis !== 'undefined' && lenis.start) {

        lenis.start();

      }

    }, '>')

    .to('.loader_wrapper', {

      display: 'none',

      duration: 0.1,

      onComplete: function() {

      }

    }, '>');




}




// Page transition animation

function pageTransitionAnimation() {

  const transitionLinks = document.querySelectorAll(

    'a:not([/**/href^="#"]):not([href^="javascript:"]):not([href=""]):not([href^="mailto:"]):not([href^="tel:"])'

  );

  transitionLinks.forEach((link) => {

    if (link.getAttribute('target') !== '_blank') {

      link.addEventListener('click', (e) => {

        e.preventDefault();



        const loaderAnimationOut = gsap.timeline({

          onComplete: () => {

            window.location.href = link.href;

          },

        });

        loaderAnimationOut.to('.unloader_wrapper', {
          display: 'flex',
          duration: 0.05
        });

        loaderAnimationOut.from('.unloader_ract', {

          duration: 0.4,

          height: '0%',

          ease: 'loader2',

        }),

          '>';

        // play the timeline

        loaderAnimationOut.play();

      });

    }

  });

}




// Header on scroll animation

const infoBar = document.querySelector('.info-bar');

const showHideHeader = gsap.timeline({
  paused: true,
})

showHideHeader.to('.navbar', {

  y: '-100%',

  duration: 0.2,

  ease: 'loader2',

})

if (infoBar) {

  showHideHeader.to('.button_small.is-navbar', {

    top: "1.75rem",

    duration: 0.2,

    ease: 'loader2',

  }, "<")
}




// Custom cursor on mousedown and mouseup

function customCursorOnClick() {

  const cursorElements = document.querySelectorAll('[wide="customCursor"]');

  const customCursor = document.querySelector('.custom_cursor');

  cursorElements.forEach((element) => {

    element.addEventListener('mousedown', function() {

      customCursor.style.transform = 'scale3d(0.8, 0.8, 1)';

    });

    element.addEventListener('mouseup', function() {

      customCursor.style.transform = 'scale3d(1, 1, 1)';

    });

  });

}



window.heroFixedSections = function(i) {

  gsap.matchMedia().add("(min-width: 992px)", () => {

    let e = document.querySelectorAll(".herofixedsection");



    e.forEach((n, s) => {

      ScrollTrigger.create({

        trigger: n,

        start: () => n.offsetHeight < window.innerHeight ? "top top" : "bottom bottom",

        pin: true,

        markers: false,

        pinSpacing: false,

        scrub: 3

      });

    });



    let r = document.querySelector(".cover-bg");

    if (r) {

      ScrollTrigger.create({

        trigger: ".cover-bg",

        start: "bottom center+=300",

        end: "bottom top+=400",

        scrub: true,

        onUpdate: (n) => {

          gsap.to(r, {
            opacity: n.progress,
            overwrite: true
          });

        }

      });

    }

  });

};




// Sliders on Services page

window.servicesSliders = function(e) {

  const config = {

    type: 'loop',

    perPage: 1,

    gap: 0,

    arrows: false,

    drag: false,

    duration: 0.15,

    easing: 'cubic-bezier(0.83, 0, 0.17, 1)',

    classes: {

      pagination: 'splide__pagination services-pagination',

      page: 'splide__pagination__page services-page',

    },

    breakpoints: {

      992: {
        drag: true,
        fixedWidth: '90%'
      },

      480: {},

    },

  };

  const slider = new Splide(e, config).mount();

  if (window.innerWidth > 992) {

    slider.on('click', function() {

      slider.go('+1');

    });

  }

  gsap.from(e, {

    scrollTrigger: {

      trigger: e,

      start: 'top bottom',

      end: 'bottom bottom+=15%',

      scrub: 1,

      once: true,

    },

    x: '10%',

    opacity: 0,

    ease: 'linear',

  });

}




window.standardHeaderScrollAnimation = function() {

  const brand = document.querySelector('.navbar_brand.scale');

  if (!brand) return; // Jeśli nie ma elementu, nie rób nic i nie syp błędami



  const enterTimeline = gsap.timeline({
    paused: true
  });

  const leaveBackTimeline = gsap.timeline({
    paused: true
  });



  enterTimeline.to(brand, {
    scale: 0.25,
    duration: 1
  });

  leaveBackTimeline.to(brand, {
    scale: 1,
    duration: 1
  });



  ScrollTrigger.create({

    start: 'top+=100 top',

    onEnter: () => {

      leaveBackTimeline.pause(0);

      enterTimeline.restart();

    },

    onLeaveBack: () => {

      enterTimeline.pause(0);

      leaveBackTimeline.restart();

    },

  });

}




// Place video inside the text

window.videoInsideText = function(e) {

  const headlineContent = e.querySelector('[class*="copy-this"]');

  const headlineSpan = e.querySelector('[class*="headline-span"]');

  headlineSpan.appendChild(headlineContent);

}



// Span video mask animation

window.spanVideoMaskAnimation = function(e) {

  gsap.to(e, {

    scrollTrigger: {
      trigger: e,
      start: 'bottom bottom-=5%'
    },

    width: 0,

    ease: 'loader2',

    duration: 0.6,

  });

}



// Custom cursor text change

window.customCursorText = function(e) {

  e.addEventListener('mouseenter', () => {

    const wideCursorTextValue = e.getAttribute('wideCursorText');

    const customCursorTextElement = document.querySelector('.custom_cursor_text');

    customCursorTextElement.innerHTML = wideCursorTextValue;

  });

}




window.heroAnimationOnLoad = function(e) {

  const video = document.getElementById('herovideo');



  // Setup początkowy

  gsap.set('.wideletter', {
    y: '-150%',
    scale: 1
  });



  function run() {

    const introBrand = document.querySelector('.preloader [intro-brand]');

    const preloader = introBrand ? introBrand.closest('.preloader') : document.querySelector('.preloader');

    const wrapIt = document.querySelector('.wrap-it') || preloader?.closest('.wrap-it') || preloader;

    const widelettersIntro = introBrand ? introBrand.querySelectorAll('.wideletter-intro') : [];



    let savedScrollY = 0;

    const preventScroll = (e) => e.preventDefault();



    function lockScroll() {

      savedScrollY = window.scrollY || document.documentElement.scrollTop;

      document.body.style.position = 'fixed';

      document.body.style.top = `-${savedScrollY}px`;

      document.body.style.left = '0';

      document.body.style.right = '0';

      document.body.style.width = '100%';

      document.body.style.overflow = 'hidden';

      document.documentElement.style.overflow = 'hidden';

      if (typeof lenis !== 'undefined' && lenis.stop) lenis.stop();

      document.addEventListener('touchmove', preventScroll, {
        passive: false
      });

    }



    function unlockScroll() {

      // iPhone / DevTools Fix: Brutalne czyszczenie

      document.body.style.cssText = '';

      document.documentElement.style.cssText = '';

      document.removeEventListener('touchmove', preventScroll);



      window.scrollTo(0, savedScrollY);



      if (typeof lenis !== 'undefined' && lenis.start) lenis.start();



      window.isPageUnlocked = true;



      // KLUCZOWE: Zabijamy cache i zmuszamy do przeliczenia na nowo

      setTimeout(() => {

        ScrollTrigger.refresh(true);



        // Jeśli podczas resizu animacje się nie zainicjowały, robimy to teraz

        gsapTitleAnimation();

        gsapContainerAnimation();

        gsapFadeAnimation();



        console.log("Layout Stabilized: Triggers Re-calculated");

      }, 400);

    }



    lockScroll();



    const heroAnimation = gsap.timeline({});



    if (preloader && introBrand && widelettersIntro.length > 0) {

      gsap.set(widelettersIntro, {
        y: '-150%',
        opacity: 1
      });



      heroAnimation.to({}, {
        duration: 0.1
      });

      heroAnimation.set('.grab', {
        opacity: 1
      });

      heroAnimation.set(introBrand, {
        opacity: 1
      });

      heroAnimation.to(widelettersIntro, {
        y: '0%',
        duration: 0.5,
        ease: 'loader2',
        stagger: 0.05
      });

      heroAnimation.to({}, {
        duration: 1.5
      });

      heroAnimation.to(widelettersIntro, {
        y: '-150%',
        opacity: 0,
        duration: 0.4,
        ease: 'power2.in',
        stagger: 0.02
      });



      heroAnimation.set(wrapIt, {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
        zIndex: 9999
      });

      heroAnimation.to(wrapIt, {

        height: '0vh',

        duration: 1.5,

        ease: 'power2.inOut',

        onStart: () => {

          if (video) {

            video.currentTime = 0;

            video.play().catch(() => {});

          }

        }

      });

    }



    const wideletters = document.querySelectorAll('.wideletter');

    if (wideletters.length > 0) {

      heroAnimation.fromTo(wideletters,

        {
          y: '-150%',
          opacity: 0
        },

        {

          y: '0%',

          opacity: 1,

          duration: 0.6,

          ease: 'loader2',

          stagger: 0.06,

          onComplete: () => {

            unlockScroll();

            gsap.set(wrapIt, {
              visibility: 'hidden',
              pointerEvents: 'none'
            });

          }

        },

        '>-0.4'

      );

    } else {

      heroAnimation.add(() => {

        unlockScroll();

        gsap.set(wrapIt, {
          visibility: 'hidden',
          pointerEvents: 'none'
        });

      });

    }

  }



  if (document.readyState === 'complete') {
    run();
  } else {
    window.addEventListener('load', run);
  }

};



window.briefContact = function(e) {

  const button = document.querySelector('.brief-button');

  const bottomOverlay = document.querySelector('#bottomWrapperOverlay');



  // Sprawdź, czy oba elementy istnieją — jeśli nie, zakończ działanie funkcji

  if (!button || !bottomOverlay) return;



  // Funkcja do aktualizacji przezroczystości przy scrollu

  function updateButtonOpacity() {

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;



    const overlayRect = bottomOverlay.getBoundingClientRect();

    const overlayTop = overlayRect.top + scrollTop;

    const overlayBottom = overlayRect.bottom + scrollTop;



    if (scrollTop >= overlayTop && scrollTop < overlayBottom) {

      button.style.opacity = 0;

    } else {

      button.style.opacity = 1;

    }

  }



  // Nasłuch na scroll + pierwszy update

  window.addEventListener('scroll', updateButtonOpacity);

  updateButtonOpacity();



  // ScrollTrigger do toggle'owania klasy

  gsap.utils.toArray('section').forEach((section, index) => {

    ScrollTrigger.create({

      trigger: section,

      start: "top top",

      end: "bottom top",

      toggleClass: {

        targets: button,

        className: 'scrolled-over',

        addTriggerCondition: self => self.direction === -1,

      },

    });

  });

}




window.contactUsHide = function(e) {

  gsap.to(e, ({

    autoAlpha: 0,

    duration: 0.15,

    ease: 'loader2',

    scrollTrigger: {

      trigger: '.contactushide',

      start: 'top center',

      toggleActions: 'play none none reverse',

    },

  }));

}



window.caseCategories = function(e) {

  // GSAP animation for hovering over .summary-title elements



  // Get all the summary title elements

  // Get all the summary title elements

  const summaryTitles = document.querySelectorAll('.summary-title');



  // Function to reset all elements to the default color

  function resetColors() {

    summaryTitles.forEach(title => {

      title.style.color = ''; // Remove the inline style to reset the color

    });

  }



  // Loop through each summary title element and add event listeners for mouseenter and mouseleave

  summaryTitles.forEach(title => {

    title.addEventListener('mouseenter', () => {

      // First, reset all colors to gray

      summaryTitles.forEach(otherTitle => {

        gsap.to(otherTitle, {
          duration: 0,
          color: 'var(--wide-gray-400)'
        });

      });



      // Then, set the hovered element to black instantly

      gsap.to(title, {
        duration: 0,
        color: 'var(--wide-black)'
      });

    });



    title.addEventListener('mouseleave', () => {

      // On mouse leave, check if any other element is hovered

      setTimeout(() => {

        const anyHovered = Array.from(summaryTitles).some(title => title.matches(':hover'));

        if (!anyHovered) {

          resetColors(); // Reset colors if no elements are hovered

        }

      }, 0);

    });

  });



}



window.textScroll = function(e) {
  let mm = gsap.matchMedia();
  mm.add("(min-width: 992px)", () => {
    const revealTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: '.stats-content_wrapper',
        start: 'top center+=200',
      }
    });
    new SplitText('#heroHeading', { type: 'lines', linesClass: 'hero-line' });
    new SplitText('#heroHeading', { type: 'lines', linesClass: 'hero-line-mask' });
    const heroLines = document.querySelectorAll('.hero-line');
    if (heroLines.length === 0) return;

    gsap.set('.hero-line', { y: '100%' });
    const revealScrollElements = document.querySelectorAll('.reveal-scroll');

    revealTimeline.fromTo(revealScrollElements, { y: '100%', opacity: 0 }, { y: '0%', opacity: 1, duration: 1.2, stagger: 0.2, ease: 'loader2' });
    revealTimeline.fromTo('.hero-line', { y: '100%' }, { duration: 1.2, y: '0%', stagger: 0.2, ease: 'loader2' }, '<');

    return () => gsap.set(['.hero-line', '.reveal-scroll'], { clearProps: "all" });
  });
};




window.HoverMaskVideo = function(root) {

  const hoverTitles = root.querySelectorAll('.hover-title');

  const hoverMasks = root.querySelectorAll('.hover-mask');

  const hoverTriggers = root.querySelectorAll('.hover-trigger');



  function resetOpacity() {

    hoverTitles.forEach(title => {

      title.style.opacity = ''; // Remove the inline style to reset the opacity

    });

  }



  function resetBgVideos(hoverMask) {

    const bgVideos = hoverMask.querySelectorAll('.bg-video');

    bgVideos.forEach(video => {

      video.style.display = ''; // Reset display property

    });

  }



  hoverTriggers.forEach((trigger, index) => {

    let isHovered = false; // Track hover state



    const animation = gsap.fromTo(

      hoverMasks[index],

      {
        height: '0rem'
      },

      {

        height: '29.6rem',

        ease: 'loader',

        duration: 0.5,

        paused: true // Animation starts in reverse

      }

    );



    const bgVideos = Array.from(hoverMasks[index].querySelectorAll('.bg-video')).reverse();



    const videoAnimation = gsap.timeline({
      paused: true,
      repeat: -1
    });

    bgVideos.forEach((video, videoIndex) => {

      videoAnimation.to(video, {

        display: 'none',

        duration: 0,

        delay: 1

      }, videoIndex * 1); // Ensure each step has a 1-second interval

    });



    trigger.addEventListener('mouseenter', () => {

      isHovered = true;

      hoverTitles[index].style.zIndex = 21; // Set z-index to 21 on hover-in

      animation.restart().play(); // Restart and play the animation



      // First, set all titles to 20% opacity

      hoverTitles.forEach((otherTitle, otherIndex) => {

        if (otherIndex !== index) {

          gsap.to(otherTitle, {
            duration: 0,
            opacity: 0.2
          });

        }

      });



      // Set the hovered title to 100% opacity instantly

      gsap.to(hoverTitles[index], {
        duration: 0,
        opacity: 1.0
      });



      // Start the video animation after the mask animation completes

      animation.eventCallback('onComplete', () => {

        videoAnimation.restart().play();

      });

    });



    trigger.addEventListener('mouseleave', () => {

      isHovered = false;

      hoverTitles[index].style.zIndex = ''; // Reset z-index instantly on hover-out

      animation.reverse(); // Reverse the animation

      videoAnimation.pause().seek(0); // Stop and reset the video animation

      resetBgVideos(hoverMasks[index]); // Reset display property of bg videos



      // On mouse leave, check if any other element is hovered

      setTimeout(() => {

        const anyHovered = Array.from(hoverTriggers).some(otherTrigger => otherTrigger.matches(':hover'));

        if (!anyHovered) {

          resetOpacity(); // Reset opacity if no elements are hovered

        }

      }, 0);

    });

  });

};



window.animationTest = function(root) {

  gsap.matchMedia().add("(min-width: 992px)", () => {

    const hoverTitles = root.querySelectorAll('.hover-title');

    const hoverMasks = root.querySelectorAll('.hover-mask');

    const hoverTriggers = root.querySelectorAll('.hover-wrapper');



    function resetOpacity() {

      hoverTitles.forEach(title => {

        title.style.opacity = ''; // Remove the inline style to reset the opacity

      });

    }



    function resetBgVideos(hoverMask) {

      const bgVideos = hoverMask.querySelectorAll('.bg-video');

      bgVideos.forEach(video => {

        video.style.display = ''; // Reset display property

      });

    }



    function setRandomPosition(element, trigger) {

      const viewportWidth = window.innerWidth;

      const viewportHeight = window.innerHeight;

      const elementWidth = 23.75 * 16; // Convert rem to pixels (assuming 1rem = 16px)

      const elementHeight = 17.5 * 16; // Convert rem to pixels (assuming 1rem = 16px)



      // Get the bounding rectangle of the trigger's hover-title

      const hoverTitle = trigger.querySelector('.hover-title');

      const hoverTitleRect = hoverTitle.getBoundingClientRect();



      let randomX, randomY;



      do {

        randomX = Math.max(0, Math.random() * (viewportWidth - elementWidth));

        randomY = Math.max(0, Math.random() * (viewportHeight - elementHeight));

      } while (

        randomX < hoverTitleRect.right &&

        randomX + elementWidth > hoverTitleRect.left &&

        randomY < hoverTitleRect.bottom &&

        randomY + elementHeight > hoverTitleRect.top

        );



      element.style.left = `${randomX}px`;

      element.style.top = `${randomY}px`;

    }



    hoverTriggers.forEach((trigger, index) => {

      let isHovered = false; // Track hover state



      const animation = gsap.fromTo(

        hoverMasks[index],

        {
          height: '0rem'
        },

        {

          height: '17.5rem',

          ease: 'loader',

          duration: 0.4,

          paused: true // Animation starts in reverse

        }

      );



      const bgVideos = Array.from(hoverMasks[index].querySelectorAll('.bg-video')).reverse();



      const videoAnimation = gsap.timeline({
        paused: true,
        repeat: -1
      });

      bgVideos.forEach((video, videoIndex) => {

        videoAnimation.to(video, {

          display: 'block',

          duration: 0,

        }, videoIndex * 0.55) // Display the video

          .to(video, {

            display: 'none',

            duration: 0,

            delay: 0.55, // Ensure each video is displayed for 0.65 seconds

          }, videoIndex * 0.55); // Ensure each step has a 1-second interval

      });



      // Set all bgVideos to display: block at the end

      videoAnimation.to(bgVideos, {
        display: 'block',
        duration: 0
      });



      animation.eventCallback('onComplete', () => {

        if (isHovered) {

          videoAnimation.restart().play(); // Start the video animation only if still hovered

        }

      });



      trigger.addEventListener('mouseenter', () => {

        isHovered = true;

        setRandomPosition(hoverMasks[index], trigger); // Set a random position on hover

        animation.restart().play(); // Restart and play the animation



        // First, set all titles to 20% opacity

        hoverTitles.forEach((otherTitle, otherIndex) => {

          if (otherIndex !== index) {

            gsap.to(otherTitle, {
              duration: 0,
              opacity: 0.2
            });

          }

        });



        // Set the hovered title to 100% opacity instantly

        gsap.to(hoverTitles[index], {
          duration: 0,
          opacity: 1.0
        });

      });



      trigger.addEventListener('mouseleave', () => {

        isHovered = false;

        animation.reverse(); // Reverse the animation

        videoAnimation.pause().seek(0); // Stop and reset the video animation

        resetBgVideos(hoverMasks[index]); // Reset display property of bg videos



        // On mouse leave, check if any other element is hovered

        setTimeout(() => {

          const anyHovered = Array.from(hoverTriggers).some(otherTrigger => otherTrigger.matches(':hover'));

          if (!anyHovered) {

            resetOpacity(); // Reset opacity if no elements are hovered

          }

        }, 0);

      });

    });

  });

};




window.animationTest1 = function(root) {

  const hoverTitles = root.querySelectorAll('.hover-title');

  const hoverMasks = root.querySelectorAll('.hover-mask');

  const hoverTriggers = root.querySelectorAll('.hover-wrapper');



  function resetOpacity() {

    hoverTitles.forEach(title => {

      title.style.opacity = ''; // Remove the inline style to reset the opacity

    });

  }




  function resetBgVideos(hoverMask) {

    if (!hoverMask) return;

    const bgVideos = hoverMask.querySelectorAll('.bg-video');

    bgVideos.forEach(video => {

      gsap.set(video, {
        display: 'none',
        x: 0,
        y: 0
      }); // Reset display and position properties using GSAP

    });

  }



  function setRandomPosition(element) {

    if (!element) return;

    const viewportWidth = window.innerWidth;

    const viewportHeight = window.innerHeight;

    const elementWidth = 23.75 * 16; // Convert rem to pixels (assuming 1rem = 16px)

    const elementHeight = 17.5 * 16; // Convert rem to pixels (assuming 1rem = 16px)



    // Ensure the element is placed within the viewport boundaries

    const maxX = viewportWidth - elementWidth;

    const maxY = viewportHeight - elementHeight;

    const randomX = Math.max(0, Math.random() * maxX);

    const randomY = Math.max(0, Math.random() * maxY);



    element.style.left = `${randomX}px`;

    element.style.top = `${randomY}px`;

  }



  // Initialize: Set all bg-videos to display: none

  hoverMasks.forEach(mask => {

    const bgVideos = mask.querySelectorAll('.bg-video');

    bgVideos.forEach(video => {

      gsap.set(video, {
        display: 'none'
      });

    });

  });



  hoverTriggers.forEach((trigger, index) => {

    if (!hoverMasks[index]) return;

    let isHovered = false; // Track hover state

    let videoAnimation = null; // Store the timeline for each trigger

    let moveAnimation = gsap.timeline({
      paused: true
    }); // Store the move timeline for each trigger



    const bgVideos = Array.from(hoverMasks[index].querySelectorAll('.bg-video'));



    // Set random position for each video when mouse enters

    function positionBgVideos() {

      bgVideos.forEach(video => setRandomPosition(video));

    }



    trigger.addEventListener('mouseenter', () => {

      isHovered = true;

      positionBgVideos(); // Set random position for each video



      // Change display property of the hover mask to flex

      hoverMasks[index].style.display = 'flex';



      // First, set all titles to 20% opacity

      hoverTitles.forEach((otherTitle, otherIndex) => {

        if (otherIndex !== index) {

          gsap.to(otherTitle, {
            duration: 0,
            opacity: 0.2
          });

        }

      });



      // Set the hovered title to 100% opacity instantly

      gsap.to(hoverTitles[index], {
        duration: 0,
        opacity: 1.0
      });



      // Create a timeline to display the videos one by one with a fixed interval

      videoAnimation = gsap.timeline();

      bgVideos.forEach((video, videoIndex) => {

        videoAnimation.to(video, {

          display: 'inline-block',

          duration: 0,

          onStart: () => setRandomPosition(video), // Set random position when the video appears

        }, videoIndex); // Ensure each video appears with a 1-second interval

      });



      videoAnimation.play();



      const xSetters = bgVideos.map(video => gsap.quickSetter(video, "x", "px"));

      const ySetters = bgVideos.map(video => gsap.quickSetter(video, "y", "px"));



      // Add the event listener for the mousemove event

      trigger.addEventListener('mousemove', (event) => {

        const {
          clientX,
          clientY
        } = event;

        const centerX = window.innerWidth / 2;

        const centerY = window.innerHeight / 2;

        const moveX = (clientX - centerX) * 0.35; // Adjust the multiplier for more or less movement

        const moveY = (clientY - centerY) * 0.35; // Adjust the multiplier for more or less movement



        bgVideos.forEach((video, videoIndex) => {

          gsap.to(video, {

            x: moveX,

            y: moveY,

            delay: videoIndex * 0.1, // Small delay for staggered effect

            duration: 1,

            ease: 'power2.out',

            overwrite: 'auto'

          });

        });

      });

    });



    trigger.addEventListener('mouseleave', () => {

      isHovered = false;



      // Change display property of the hover mask back to none

      hoverMasks[index].style.display = 'none';



      // Reset all bg-videos to display: none and reset position

      resetBgVideos(hoverMasks[index]);



      // Clear the animation timeline if it exists

      if (videoAnimation) {

        videoAnimation.kill();

        videoAnimation = null;

      }



      // Clear the move animation timeline if it exists

      if (moveAnimation) {

        moveAnimation.kill();

        moveAnimation = gsap.timeline({
          paused: true
        });

      }



      // On mouse leave, check if any other element is hovered

      setTimeout(() => {

        const anyHovered = Array.from(hoverTriggers).some(otherTrigger => otherTrigger.matches(':hover'));

        if (!anyHovered) {

          resetOpacity(); // Reset opacity if no elements are hovered

        }

      }, 0);

    });

  });

};



window.animationTest2 = function(root) {

  const hoverTitles = root.querySelectorAll('.hover-title');

  const hoverMasks = root.querySelectorAll('.hover-mask');

  const hoverTriggers = root.querySelectorAll('.hover-wrapper');



  function resetOpacity() {

    hoverTitles.forEach(title => {

      title.style.opacity = ''; // Remove the inline style to reset the opacity

    });

  }



  function resetBgVideos(hoverMask) {

    const bgVideos = hoverMask.querySelectorAll('.bg-video');

    bgVideos.forEach(video => {

      video.style.display = ''; // Reset display property

    });

  }



  function setRandomPosition(element) {

    const viewportWidth = window.innerWidth;

    const viewportHeight = window.innerHeight;

    const elementWidth = 23.75 * 16; // Convert rem to pixels (assuming 1rem = 16px)

    const elementHeight = 17.5 * 16; // Convert rem to pixels (assuming 1rem = 16px)



    // Ensure the element is placed within the viewport boundaries

    const maxX = viewportWidth - elementWidth;

    const maxY = viewportHeight - elementHeight;

    const randomX = Math.max(0, Math.random() * maxX);

    const randomY = Math.max(0, Math.random() * maxY);



    element.style.left = `${randomX}px`;

    element.style.top = `${randomY}px`;

  }



  hoverTriggers.forEach((trigger, index) => {

    let isHovered = false; // Track hover state



    const animation = gsap.fromTo(

      hoverMasks[index],

      {
        height: '0rem'
      },

      {

        height: '17.5rem',

        ease: 'loader',

        duration: 0.5,

        paused: true // Animation starts in reverse

      }

    );



    const bgVideos = Array.from(hoverMasks[index].querySelectorAll('.bg-video')).reverse();



    // Set random position for each video when mouse enters

    function positionBgVideos() {

      bgVideos.forEach(video => setRandomPosition(video));

    }



    trigger.addEventListener('mouseenter', () => {

      isHovered = true;

      positionBgVideos(); // Set random position for each video

      setRandomPosition(hoverMasks[index]); // Set a random position on hover

      animation.restart().play(); // Restart and play the animation



      // First, set all titles to 20% opacity

      hoverTitles.forEach((otherTitle, otherIndex) => {

        if (otherIndex !== index) {

          gsap.to(otherTitle, {
            duration: 0,
            opacity: 0.2
          });

        }

      });



      // Set the hovered title to 100% opacity instantly

      gsap.to(hoverTitles[index], {
        duration: 0,
        opacity: 1.0
      });



      // Display all bg-videos immediately after mask animation completes

      animation.eventCallback('onComplete', () => {

        bgVideos.forEach(video => {

          gsap.set(video, {
            display: 'inline-block'
          });

        });

      });

    });



    trigger.addEventListener('mousemove', (event) => {

      if (!isHovered) return;



      const {
        clientX,
        clientY
      } = event;

      const centerX = window.innerWidth / 2;

      const centerY = window.innerHeight / 2;

      const moveX = (clientX - centerX) * 1; // Adjust the multiplier for more or less movement

      const moveY = (clientY - centerY) * 1; // Adjust the multiplier for more or less movement



      bgVideos.forEach((video, videoIndex) => {

        gsap.to(video, {

          x: moveX,

          y: moveY,

          delay: videoIndex * 0.05, // Small delay for staggered effect

          duration: 0.5,

          ease: 'power2.out',

          overwrite: 'auto'

        });

      });

    });



    trigger.addEventListener('mouseleave', () => {

      isHovered = false;

      animation.reverse(); // Reverse the animation

      resetBgVideos(hoverMasks[index]); // Reset display property of bg videos



      // On mouse leave, check if any other element is hovered

      setTimeout(() => {

        const anyHovered = Array.from(hoverTriggers).some(otherTrigger => otherTrigger.matches(':hover'));

        if (!anyHovered) {

          resetOpacity(); // Reset opacity if no elements are hovered

        }

      }, 0);

    });

  });

};




window.animationTest3 = function(root) {

  const hoverTitles = root.querySelectorAll('.hover-title');

  const hoverMasks = root.querySelectorAll('.hover-mask');

  const hoverTriggers = root.querySelectorAll('.hover-wrapper');



  function resetOpacity() {

    hoverTitles.forEach(title => {

      title.style.opacity = ''; // Remove the inline style to reset the opacity

    });

  }



  function resetBgVideos(hoverMask) {

    const bgVideos = hoverMask.querySelectorAll('.bg-video');

    bgVideos.forEach(video => {

      video.style.display = ''; // Reset display property

    });

  }



  function centerElementOnCursor(element, x, y) {

    const elementWidth = 23.75 * 16; // Convert rem to pixels (assuming 1rem = 16px)

    const elementHeight = 17.5 * 16; // Convert rem to pixels (assuming 1rem = 16px)



    // Calculate the centered position

    const left = x - elementWidth / 2;

    const top = y - elementHeight / 2;



    element.style.left = `${left}px`;

    element.style.top = `${top}px`;

  }



  hoverTriggers.forEach((trigger, index) => {

    let isHovered = false; // Track hover state



    const animation = gsap.fromTo(

      hoverMasks[index],

      {
        height: '0rem'
      },

      {

        height: '17.5rem',

        ease: 'loader',

        duration: 0.5,

        paused: true // Animation starts in reverse

      }

    );



    const bgVideos = Array.from(hoverMasks[index].querySelectorAll('.bg-video')).reverse();



    const videoAnimation = gsap.timeline({
      paused: true,
      repeat: -1
    });

    bgVideos.forEach((video, videoIndex) => {

      videoAnimation.to(video, {

        display: 'none',

        duration: 0,

        delay: 1

      }, videoIndex * 1); // Ensure each step has a 1-second interval

    });



    trigger.addEventListener('mouseenter', (event) => {

      isHovered = true;

      centerElementOnCursor(hoverMasks[index], event.clientX, event.clientY); // Center on cursor

      animation.restart().play(); // Restart and play the animation



      // First, set all titles to 20% opacity

      hoverTitles.forEach((otherTitle, otherIndex) => {

        if (otherIndex !== index) {

          gsap.to(otherTitle, {
            duration: 0,
            opacity: 0.2
          });

        }

      });



      // Set the hovered title to 100% opacity instantly

      gsap.to(hoverTitles[index], {
        duration: 0,
        opacity: 1.0
      });



      // Start the video animation after the mask animation completes

      animation.eventCallback('onComplete', () => {

        videoAnimation.restart().play();

      });

    });



    trigger.addEventListener('mousemove', (event) => {

      if (isHovered) {

        centerElementOnCursor(hoverMasks[index], event.clientX, event.clientY); // Update position on cursor move

      }

    });



    trigger.addEventListener('mouseleave', () => {

      isHovered = false;

      animation.reverse(); // Reverse the animation

      videoAnimation.pause().seek(0); // Stop and reset the video animation

      resetBgVideos(hoverMasks[index]); // Reset display property of bg videos



      // On mouse leave, check if any other element is hovered

      setTimeout(() => {

        const anyHovered = Array.from(hoverTriggers).some(otherTrigger => otherTrigger.matches(':hover'));

        if (!anyHovered) {

          resetOpacity(); // Reset opacity if no elements are hovered

        }

      }, 0);

    });

  });

};



window.animationTest4 = function(root) {

  const hoverWrappers = root.querySelectorAll('.h-wrapper');

  const hoverMasks = root.querySelectorAll('.hover-mask');

  const hoverTitles = root.querySelectorAll('.h-title');



  const VIDEO_WIDTH = 380;

  const VIDEO_HEIGHT = 280;

  const VISIBLE_RATIO = 0.7;



  hoverMasks.forEach(mask => {

    mask.style.display = 'none';

    mask.style.position = 'fixed';

    mask.style.top = '0';

    mask.style.left = '0';

    mask.style.width = '100vw';

    mask.style.height = '100vh';

    mask.style.zIndex = '999';

    mask.style.pointerEvents = 'none';

  });



  function resetOpacity() {

    hoverTitles.forEach(title => {

      title.style.opacity = '';

    });

  }



  function resetBgVideos(mask) {

    const videos = mask.querySelectorAll('.bg-video');

    videos.forEach(video => {

      video.style.display = 'none';

      video.style.left = '';

      video.style.top = '';

      video.style.position = '';

      video.style.zIndex = '';

    });

  }



  function placeElementAtRandomVisiblePosition(el, container) {

    const containerWidth = container.offsetWidth;

    const containerHeight = container.offsetHeight;



    const minVisibleWidth = VIDEO_WIDTH * VISIBLE_RATIO;

    const minVisibleHeight = VIDEO_HEIGHT * VISIBLE_RATIO;



    const maxLeft = containerWidth - minVisibleWidth;

    const maxTop = containerHeight - minVisibleHeight;



    let left = Math.random() * maxLeft;

    let top = Math.random() * maxTop;



    if (left + VIDEO_WIDTH > containerWidth) left = containerWidth - VIDEO_WIDTH;

    if (top + VIDEO_HEIGHT > containerHeight) top = containerHeight - VIDEO_HEIGHT;



    el.style.left = `${left}px`;

    el.style.top = `${top}px`;

    el.style.position = 'absolute';

    el.style.width = `${VIDEO_WIDTH}px`;

    el.style.height = `${VIDEO_HEIGHT}px`;

    el.style.pointerEvents = 'none';

  }



  hoverWrappers.forEach((wrapper, index) => {

    const title = hoverTitles[index];

    const mask = hoverMasks[index];

    const videos = mask.querySelectorAll('.bg-video');

    let videoTimeline = null;

    let isActive = false;



    videos.forEach(video => {

      video.style.display = 'none';

      video.style.width = `${VIDEO_WIDTH}px`;

      video.style.height = `${VIDEO_HEIGHT}px`;

      video.style.position = 'absolute';

      video.style.pointerEvents = 'none';

    });



    wrapper.addEventListener('mouseenter', () => {

      if (isActive) return;

      isActive = true;



      resetBgVideos(mask);

      mask.style.display = 'block';



      hoverTitles.forEach((t, i) => {

        t.style.opacity = i === index ? '1' : '0.2';

      });



      videoTimeline = gsap.timeline();



      const videoIndexes = Array.from({
        length: videos.length
      }, (_, i) => i);

      const shuffledIndexes = videoIndexes.sort(() => Math.random() - 0.5);



      shuffledIndexes.forEach((videoIndex, timeIndex) => {

        const video = videos[videoIndex];



        videoTimeline.add(() => {

          placeElementAtRandomVisiblePosition(video, mask);

          video.style.zIndex = 1001 + timeIndex; // <-- z-index rośnie

        }, timeIndex * 0.75);



        videoTimeline.to(video, {

          display: 'block',

          duration: 0

        }, timeIndex * 0.75);

      });



      videoTimeline.play();

    });



    wrapper.addEventListener('mouseleave', () => {

      isActive = false;



      if (videoTimeline) {

        videoTimeline.kill();

        videoTimeline = null;

      }



      mask.style.display = 'none';

      resetBgVideos(mask);



      setTimeout(() => {

        const anyHovered = Array.from(hoverWrappers).some(el => el.matches(':hover'));

        if (!anyHovered) resetOpacity();

      }, 0);

    });

  });

};




window.pricingInteraction = function(e) {



  // Check if the screen width is 992px or wider

  if (window.innerWidth >= 992) {



    const tabsContent = document.querySelector('.tabs-content');

    const tabsMenu = document.querySelector('.tabs-menu');



    console.log('[pricingInteraction] .tabs-content found:', tabsContent);

    console.log('[pricingInteraction] .tabs-menu found:', tabsMenu);



    if (!tabsContent || !tabsMenu) {

      return;

    }



    // Debug computed styles

    const tabsContentStyles = window.getComputedStyle(tabsContent);

    const tabsMenuStyles = window.getComputedStyle(tabsMenu);



    // Create the pinning effect

    const trigger = ScrollTrigger.create({

      trigger: ".tabs-content",

      start: "top-=48px top",

      end: "bottom bottom",

      pin: ".tabs-menu",



    });



  }

};



// Optionally, you may want to add an event listener to handle window resizing if the functionality needs to be responsive

window.addEventListener('resize', function() {

  // Clear existing ScrollTriggers if necessary and reapply for the new size

  ScrollTrigger.getAll().forEach(trigger => trigger.kill());

  window.pricingInteraction();

});

window.caseStudyInteraction = function(e) {
  let mm = gsap.matchMedia();
  mm.add("(min-width: 992px)", () => {
    const mask = e.querySelector('.portfolio_item_image-mask');
    if (mask) {
      gsap.to(mask, {
        scaleX: 0,
        duration: 1.5,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: mask,
          start: 'top 85%',
          toggleActions: 'play none none none'
        }
      });
    }
    return () => { if(mask) gsap.set(mask, { clearProps: "all" }); };
  });
}



let panels = gsap.utils.toArray(".panel");

// we'll create a ScrollTrigger for each panel just to track when each panel's top hits the top of the viewport (we only need this for snapping)

let tops = panels.map(panel => ScrollTrigger.create({
  trigger: panel,
  start: "top top"
}));



panels.forEach((panel, i) => {

  ScrollTrigger.create({

    trigger: panel,

    start: () => panel.offsetHeight < window.innerHeight ? "top top" : "bottom bottom", // if it's shorter than the viewport, we prefer to pin it at the top

    pin: true,

    pinSpacing: false

  });

});



ScrollTrigger.create({

  snap: {

    snapTo: (progress, self) => {

      let panelStarts = tops.map(st => st.start), // an Array of all the starting scroll positions. We do this on each scroll to make sure it's totally responsive. Starting positions may change when the user resizes the viewport

        snapScroll = gsap.utils.snap(panelStarts, self.scroll()); // find the closest one

      return gsap.utils.normalize(0, ScrollTrigger.maxScroll(window), snapScroll); // snapping requires a progress value, so convert the scroll position into a normalized progress value between 0 and 1

    },

    duration: 0.5

  }

});




// Reviews slider

window.reviewsSlider = function(e) {

  // Put content of static slide into list

  const staticContent = e.querySelector(

    '.splide__slide.reviews_collection_item.is-static'

  ).innerHTML;

  const dynamicElement = e.querySelector('.reviews_collection_item');

  dynamicElement.innerHTML = staticContent;

  dynamicElement.classList.add('is-static');



  // Init reviews splide

  const reviewsSplide = new Splide(e, {

    type: 'slide',

    fixedWidth: '24.5rem',

    rewind: true,

    focus: 0,

    padding: {
      left: '2.5rem',
      right: 0
    },

    gap: 0,

    omitEnd: true,

    arrows: false,

    drag: false,

    easing: 'cubic-bezier(0.83, 0, 0.17, 1)',

    snap: true,

    classes: {

      pagination: 'splide__pagination reviews-pagination',

      page: 'splide__pagination__page reviews-page',

    },

    breakpoints: {

      992: {
        fixedWidth: '17.438rem',
        padding: {
          left: '1.75rem'
        },
        drag: 'free',
        snap: false
      },

      480: {
        fixedWidth: '16.25rem',
        padding: {
          left: '1.375rem'
        }
      },

    },

  }).mount();



  // Next slide on click

  if (window.innerWidth > 992) {

    reviewsSplide.on('click', function() {

      reviewsSplide.go('+1');

    });

  }



  // Animation in

  gsap.from(e, {

    scrollTrigger: {

      trigger: e,

      start: 'top bottom',

      end: 'bottom bottom-=15%',

      scrub: 1,

      once: true,

    },

    x: '10%',

    opacity: 0,

    ease: 'linear',

  });

}



// Reviews slider

window.reviewsSlider = function(e) {

  // Put content of static slide into list

  const staticContent = e.querySelector(

    '.splide__slide.reviews_collection_item.is-static'

  ).innerHTML;

  const dynamicElement = e.querySelector('.reviews_collection_item');

  dynamicElement.innerHTML = staticContent;

  dynamicElement.classList.add('is-static');



  // Init reviews splide

  const reviewsSplide = new Splide(e, {

    type: 'slide',

    fixedWidth: '24.5rem',

    rewind: true,

    focus: 0,

    padding: {
      left: '2.5rem',
      right: 0
    },

    gap: 0,

    omitEnd: true,

    arrows: false,

    drag: false,

    easing: 'cubic-bezier(0.83, 0, 0.17, 1)',

    snap: true,

    classes: {

      pagination: 'splide__pagination reviews-pagination',

      page: 'splide__pagination__page reviews-page',

    },

    breakpoints: {

      992: {
        fixedWidth: '17.438rem',
        padding: {
          left: '1.75rem'
        },
        drag: 'free',
        snap: false
      },

      480: {
        fixedWidth: '16.25rem',
        padding: {
          left: '1.375rem'
        }
      },

    },

  }).mount();



  // Next slide on click

  if (window.innerWidth > 992) {

    reviewsSplide.on('click', function() {

      reviewsSplide.go('+1');

    });

  }



  // Animation in

  gsap.from(e, {

    scrollTrigger: {

      trigger: e,

      start: 'top bottom',

      end: 'bottom bottom-=15%',

      scrub: 1,

      once: true,

    },

    x: '10%',

    opacity: 0,

    ease: 'linear',

  });

}



// Facts slider

window.factsSlider = function(e) {

  // Facts slider splide initialize

  const factsSplide = new Splide(e, {

    type: 'loop',

    perPage: 1,

    gap: 0,

    arrows: false,

    drag: false,

    duration: 0.15,

    easing: 'cubic-bezier(0.83, 0, 0.17, 1)',

    classes: {

      pagination: 'splide__pagination facts-pagination',

      page: 'splide__pagination__page facts-page',

    },

    breakpoints: {

      992: {
        gap: '1.75rem',
        drag: true
      },

      480: {
        gap: '1.375rem'
      },

    },

  }).mount();

  // Next on click

  if (window.innerWidth > 992) {

    factsSplide.on('click', function() {

      factsSplide.go('+1');

    });

  }



  // Click on external link

  const externalLink = e.querySelectorAll('.external_link.is-cursor');

  // Loop through each element and execute customCursorIn.reverse()

  externalLink.forEach((link) => {

    link.addEventListener('click', () => {

      event.stopPropagation();

    });

  });



  // Animations

  // Function to play video on the active slide

  function playActiveSlideVideo(newIndex) {

    var activeSlide = factsSplide.Components.Elements.slides[newIndex];

    var activeVideo = activeSlide.querySelector('video');

    if (activeVideo) {

      activeVideo.play();

    }

  }



  // Function to pause and rewind videos on inactive slides

  function pauseAndRewindInactiveVideos(newIndex) {

    var slides = factsSplide.Components.Elements.slides;

    slides.forEach(function(slide, index) {

      var video = slide.querySelector('video');

      if (video && index !== newIndex) {

        video.pause();

        video.currentTime = 0; // rewind the video

      }

    });

  }

  // Function to animate elements on the active slide

  function animateSlideElements(slide) {

    gsap.fromTo(

      [

        slide.querySelector('.is-h4'),

        slide.querySelector('.facts-slide_legend-wrapper'),

        slide.querySelector('.facts-slide_diagram-wrapper'),

        slide.querySelector('.facts-slide_source')

      ],

      {

        x: '2rem',

        opacity: 0

      },

      {

        x: '0',

        opacity: 1,

        stagger: 0.2,

        duration: 0.5,

        easing: 'loader2'

      }

    );

  }

  // Function to reset animation for the elements in the slide

  function resetSlideAnimation(slide) {

    gsap.set(

      [

        slide.querySelector('.is-h4'),

        slide.querySelector('.facts-slide_legend-wrapper'),

        slide.querySelector('.facts-slide_diagram-wrapper'),

        slide.querySelector('.facts-slide_source')

      ],

      {

        x: '2rem',

        opacity: 0

      }

    );

  }

  // Event listener for 'move' event

  factsSplide.on('move', function(newIndex) {

    playActiveSlideVideo(newIndex);

    var activeSlide = factsSplide.Components.Elements.slides[newIndex];

    animateSlideElements(activeSlide);

  });

  // Event listener for 'moved' event

  factsSplide.on('moved', function(oldIndex) {

    pauseAndRewindInactiveVideos(oldIndex);

    var previousSlide = factsSplide.Components.Elements.slides[oldIndex];

    resetSlideAnimation(previousSlide);

  });



}




// Team slider

window.teamSlider = function(e) {

  // Randomize order of slides

  const teamList = e.querySelector('.team_collection_list');

  const teamItems = Array.from(teamList.children);

  teamItems.sort(function() {

    return 0.5 - Math.random();

  });

  teamItems.forEach(function(item) {

    teamList.appendChild(item);

  });



  // Team slider splide initialize

  new Splide(e, {

    type: 'slide',

    fixedWidth: '20%',

    padding: {
      left: '2.5rem',
      right: 0
    },

    focus: 0,

    gap: 0,

    pagination: false,

    omitEnd: true,

    arrows: false,

    drag: true,

    easing: 'cubic-bezier(0.83, 0, 0.17, 1)',

    snap: true,

    classes: {

      pagination: 'splide__pagination facts-pagination',

      page: 'splide__pagination__page facts-page',

    },

    breakpoints: {

      992: {
        fixedWidth: '40%',
        padding: {
          left: '1.75rem'
        },
        drag: 'free',
        snap: false
      },

      560: {
        fixedWidth: '75%',
        padding: {
          left: '1.375rem'
        },
        drag: 'free',
        snap: false
      },

    },

  }).mount();



  // Animation in

  gsap.from(e, {

    scrollTrigger: {

      trigger: e,

      start: 'top bottom',

      end: 'bottom bottom',

      scrub: 1,

      once: true,

    },

    x: '10%',

    opacity: 0,

    ease: 'linear',

  });

}




window.elementPaddingChange = function(e) {

  gsap.to(e, {

    paddingLeft: '0rem',

    paddingRight: '0rem',

    ease: 'linear',

    scrollTrigger: {

      trigger: e,

      start: () => `top ${window.innerHeight * 0.9}px`,

      end: () => `top ${window.innerHeight * 0.1}px`,

      scrub: true,

      invalidateOnRefresh: true,

    },

  });

};




// Section bg change

window.sectionBgChange = function(e) {

  gsap.set(e, {
    backgroundColor: '#fff'
  });

  gsap.set('#heroNavbarLottie path', {
    fill: 'rgb(21, 21, 21)'
  });

  const sectionsBgChange = gsap.timeline({

    duration: 0.15,

    ease: 'loader2',

    scrollTrigger: {

      trigger: e,

      start: 'top center',

      end: 'bottom top',

      toggleActions: 'play reverse play reverse',

    },

  });

  sectionsBgChange.to(['#skills', '#portfolio'], {

    backgroundColor: '#151515',

  }, '<');

  sectionsBgChange.to(".info-bar_wrapper", {

    backgroundColor: '#2E2E2E',

    color: "#fff"

  }, '<');

  // Change navbar element on bg animation

  sectionsBgChange.to(

    [

      '.button_small',

      '.button_small_icon',

      '.navbar_brand_svg',

      '#heroNavbarLottie path ',

    ],

    {

      color: '#fff',

      fill: 'rgb(254, 254, 254)',

    },

    '<'

  );

  if (window.innerWidth > 992) {

    sectionsBgChange.to(

      '.navbar_menu_link',

      {

        color: '#fff',

        fill: 'rgb(254, 254, 254)',

      },

      '<'

    );

  }

}



// Awwwards badge color change

window.badgeColorChange = function(e) {

  const badgeColorChange = gsap.timeline({

    duration: 0.15,

    ease: 'loader2',

    scrollTrigger: {

      trigger: e,

      start: 'top center',

      end: 'bottom center',

      toggleActions: 'play reverse play reverse',

    },

  });

  badgeColorChange.to(".js-color-bg", {

    fill: '#2E2E2E',

  }, '<');

  badgeColorChange.to(".js-color-text", {

    fill: '#fff',

  }, '<');

}



window.clientLogosAnimation = function(e) {
  let mm = gsap.matchMedia();
  mm.add("(min-width: 992px)", () => {
    const logoMask = e.querySelectorAll('[class*="item_mask"]');
    const logoImg = e.querySelectorAll('[class*="image"]');

    gsap.from(logoMask, {
      scrollTrigger: { trigger: logoMask, start: 'top bottom-=25%' },
      width: '0%', duration: 0.7, ease: 'loader2', stagger: 0.15,
    });
    gsap.from(logoImg, {
      scrollTrigger: { trigger: logoMask, start: 'top bottom-=25%' },
      opacity: 0, delay: 0.4, duration: 0.45, ease: 'loader2', stagger: 0.15,
    });
    return () => gsap.set([logoMask, logoImg], { clearProps: "all" });
  });
}



window.hueAwardsAnimation = function(e) {
  let mm = gsap.matchMedia();
  mm.add("(max-width: 991px)", () => {
    const logoItems = e.querySelectorAll('.clients_collection_item_mask.is-3');

    logoItems.forEach((maskEl) => {
      const imgEl = maskEl.querySelector('.skills-item_img');
      if (!imgEl) return;

      gsap.set(maskEl, { height: '100%' });

      gsap.to(maskEl, {
        scrollTrigger: {
          trigger: maskEl,
          start: 'top bottom-=25%',
        },
        height: '0%',
        duration: 0.7,
        ease: 'loader2',
      });

      gsap.from(imgEl, {
        scrollTrigger: {
          trigger: maskEl,
          start: 'top bottom-=25%',
        },
        opacity: 0,
        delay: 0.4,
        duration: 0.45,
        ease: 'loader2',
      });
    });
  });
};


// Hero span video on hover

window.heroSpanVideoOnHover = function(e) {

  window.customCursorText(e);

  const heroSpanContentAnimation = gsap.timeline({
    paused: true,
    ease: 'loader2'
  });

  heroSpanContentAnimation.to('.hero-line-mask', {
    clipPath: 'none',
    duration: 0.05
  }, '>');

  heroSpanContentAnimation.to(e, {
    scale: 2,
    duration: 0.35
  }, '>');

  if (window.innerWidth > 992) {

    e.addEventListener('mouseenter', () => {

      heroSpanContentAnimation.timeScale(1).play();

    });

    e.addEventListener('mouseleave', () => {

      heroSpanContentAnimation.timeScale(2).reverse();

    });

  }

}



window.reelModal = function() {

  const reelTrigger = document.querySelectorAll('[wideClick="playReel"]');

  const reelModal = document.querySelector('.reel-modal');

  const reelModalPlayer = document.getElementById('fullReel');



  // Jeśli nie ma wymaganych elementów – zakończ funkcję

  if (!reelTrigger.length || !reelModal || !reelModalPlayer) return;



  const reelPlayback = 0;

  const reelModalShow = gsap.timeline({
    ease: 'loader2',
    paused: true
  });



  reelModalShow.to(reelModal, {
    display: 'flex',
    opacity: 0,
    duration: 0
  });

  reelModalShow.to(reelModal, {
    opacity: 1,
    duration: 0.6
  }, '>');



  if (window.innerWidth > 992) {

    reelTrigger.forEach((element) => {

      element.addEventListener('click', () => {

        lenis.stop();

        reelModalShow.timeScale(1).play();



        if (reelPlayback === 0) {

          if (reelModalPlayer.canPlayType('video/webm')) {

            reelModalPlayer.src = 'https://widelabco.sfo3.cdn.digitaloceanspaces.com/Widelab-reel.webm';

          } else {

            reelModalPlayer.src = 'https://widelabco.sfo3.cdn.digitaloceanspaces.com/Widelab-reel.mp4';

          }

          reelModalPlayer.load();

        } else {

          return;

        }



        reelModalPlayer.play();

      });

    });



    reelModal.addEventListener('click', () => {

      reelModalShow.timeScale(4).reverse();

      reelModalPlayer.pause();

      lenis.start();

    });



    window.addEventListener('keydown', function(event) {

      if (event.keyCode === 27) {

        reelModalShow.timeScale(4).reverse();

        reelModalPlayer.pause();

        lenis.start();

      }

    });

  } else {

    reelTrigger.forEach((element) => {

      element.addEventListener('click', () => {

        if (reelModalPlayer.canPlayType('video/webm')) {

          reelModalPlayer.src = 'https://widelabco.sfo3.cdn.digitaloceanspaces.com/Widelab-reel.webm';

        } else {

          reelModalPlayer.src = 'https://widelabco.sfo3.cdn.digitaloceanspaces.com/Widelab-reel.mp4';

        }



        reelModalPlayer.load();



        reelModalPlayer.addEventListener(

          'canplaythrough',

          () => {

            reelModalPlayer.play();

          },

          {
            once: true
          }

        );

      });

    });



    reelModal.addEventListener('click', () => {

      reelModalPlayer.pause();

    });

  }

};



// Founders tooltip

window.foundersTooltip = function(e) {

  const line = e.querySelector('.line');

  const arrow = e.querySelector('.arrow');

  const foundersHover = gsap.timeline({
    paused: true,
    ease: 'loader2'
  });

  foundersHover.from(e, {

    x: '5%',

    opacity: 0,

    duration: 0.4,

  });

  foundersHover.from(

    line,

    {

      drawSVG: '0% 0%',

      duration: 0.2,

    },

    '>-0.2'

  );

  foundersHover.from(arrow, {

    drawSVG: '0% 0%',

    duration: 0.15,

  }),

    '>';

  if (window.innerWidth > 992) {

    e.addEventListener('mouseenter', () => {

      foundersHover.timeScale(1).play();

    });

    e.addEventListener('mouseleave', () => {

      foundersHover.timeScale(3).reverse();

    });

  }

}



// Clients map actions

window.clientsMapActions = function(e) {

  // Map animation

  const mapAnimation = gsap.timeline({

    scrollTrigger: {

      trigger: '.reviews_map_base',

      start: 'bottom-=160px bottom',

    },

  });

  mapAnimation.from('.map-point', {

    duration: 1,

    opacity: 0,

    stagger: 0.1,

    ease: 'loader2',

  });

  mapAnimation.from(

    '.map-pin_wrapper',

    {

      duration: 1,

      opacity: 0,

      stagger: 0.1,

      ease: 'loader2',

    },

    '0.3'

  );



  // Map pins animation on hover

  const allMapPins = document.querySelectorAll('.map-pin_wrapper');

  allMapPins.forEach(function(element) {

    element.addEventListener('mouseenter', function() {

      const mapPin = this.getAttribute('w-map-pin');

      const oldPin = document.querySelectorAll('.map_info-collection-item');

      const infoElements = document.querySelectorAll(

        ".map_info-collection-item[w-map-info='" + mapPin + "']"

      );

      const infoElementsAppear = gsap.timeline({});

      infoElementsAppear.to(oldPin, {

        opacity: 0,

        ease: 'loader2',

        duration: 0.1,

      });

      infoElementsAppear.to(oldPin, {

        display: 'none',

        duration: 0.01,

      });

      infoElementsAppear.to(infoElements, {

        display: 'block',

        duration: 0.01,

      });

      infoElementsAppear.to(infoElements, {

        opacity: 1,

        ease: 'loader2',

        duration: 0.2,

      });

    });

  });

  // Map boxes link special code

  const elements = document.querySelectorAll('.map_info-wrapper');

  for (let i = 0; i < elements.length; i++) {

    const href = elements[i].getAttribute('href');

    if (href && href.length > 3) {

      elements[i].style.cursor = 'pointer';

    }

  }

}



// Stats section headline animation

window.statsHeadlineAnimation = function() {

  const statsHeadlineAnimation = gsap.timeline({

      scrollTrigger: {

        trigger: '#statsKnow',

        start: 'center center',

        toggleActions: 'restart none none reverse',

        end: '+=500',

      },

      pause: 'paused',

      ease: 'defaultEase',

    }),

    homeStatsHeading = new SplitText('#statsDone', {

      type: 'lines',

      linesClass: 'stats-line',

    }),

    homeStatsHeadingMask = new SplitText('#statsDone', {

      type: 'lines',

      linesClass: 'stats-line-mask',

    });

  statsHeadlineAnimation.to(

    '#statsKnow',

    {

      duration: 0.5,

      opacity: 0,

      display: 'none',

    },

    '>'

  );

  statsHeadlineAnimation.from('.stats-line', {

    duration: 0.5,

    opacity: 0,

    y: '100%',

    stagger: 0.25,

  });

}




// GSAP Counter Up Animation

window.counterUpAnimation = function() {

  const counters = document.querySelectorAll('#counter');



  counters.forEach(counter => {

    // Get the final value from the element's text content and parse it as a float

    const finalValue = parseFloat(counter.textContent.replace(/,/g, '')); // Handle comma-separated numbers



    // Create a GSAP animation for the counter

    gsap.fromTo(counter,

      {
        innerHTML: 0
      },

      {

        innerHTML: finalValue,

        duration: 2, // Animation duration in seconds

        ease: 'power1.inOut',

        snap: {
          innerHTML: 1
        }, // Ensure whole numbers

        onUpdate: function() {

          // Update the element's text content with the current value

          counter.textContent = this.targets()[0].innerHTML.toLocaleString(); // Format with commas if needed

        }

      }

    );

  });

}



// Sliders on Clients page

window.heroSliders = function(e) {

  console.log("Initializing Splide on element:", e);



  const config = {

    type: 'loop',

    perPage: 1,

    gap: 0,

    arrows: false,

    drag: false,

    duration: 0.15,

    easing: 'cubic-bezier(0.83, 0, 0.17, 1)',

    classes: {

      pagination: 'splide__pagination hero-pagination',

      page: 'splide__pagination__page hero-page',

    },

    breakpoints: {

      992: {
        drag: true
      },

      480: {},

    },

  };

  const slider = new Splide(e, config).mount();



  if (window.innerWidth > 992) {

    slider.on('click', function() {

      slider.go('+1');

    });

  }

  gsap.from(e, {

    scrollTrigger: {

      trigger: e,

      start: 'top bottom',

      end: 'bottom bottom+=15%',

      scrub: 1,

      once: true,

    },

    x: '10%',

    opacity: 0,

    ease: 'linear',

  });

}




window.whatsNext = function() {

  const caseItem = document.querySelectorAll('.whats-next_links_item.is-case');

  const allCases = document.querySelector('.whats-next_links_item.is-all');



  if (!caseItem.length) return;



  caseItem.forEach((item) => {

    const imageMask = item.querySelector('.whats-next_links_item_image_mask');

    const imageWrapper = item.querySelector('.whats-next_links_item_image-wrapper');



    // Sprawdź czy oba elementy istnieją

    if (!imageMask || !imageWrapper) return;



    const whatsNextHover = gsap.timeline({
      paused: true,
      ease: 'loader2'
    });

    whatsNextHover.to(imageWrapper, {
      opacity: 0.8,
      duration: 0.15
    });

    whatsNextHover.to(imageMask, {
      width: '0%',
      duration: 0.3
    }, '>-0.');



    item.addEventListener('mouseenter', (event) => {

      whatsNextHover.timeScale(1).play();

      caseItem.forEach((i) => {

        if (i !== event.currentTarget) {

          gsap.to(i, {
            color: '#7A7A7A',
            duration: 0.2,
            ease: 'loader2'
          });

        }

      });

    });



    item.addEventListener('mouseleave', (event) => {

      whatsNextHover.timeScale(3).reverse();

      caseItem.forEach((i) => {

        if (i !== event.currentTarget) {

          gsap.to(i, {
            color: '#fff',
            duration: 0.1,
            ease: 'loader2'
          });

        }

      });

    });

  });



  if (allCases) {

    allCases.addEventListener('mouseenter', () => {

      gsap.to(allCases, {
        color: '#fff',
        duration: 0.2,
        ease: 'loader2'
      });

      caseItem.forEach((item) => {

        gsap.to(item, {
          color: '#7A7A7A',
          duration: 0.2,
          ease: 'loader2'
        });

      });

    });



    allCases.addEventListener('mouseleave', () => {

      gsap.to(allCases, {
        color: '#7A7A7A',
        duration: 0.2,
        ease: 'loader2'
      });

      caseItem.forEach((item) => {

        gsap.to(item, {
          color: '#fff',
          duration: 0.2,
          ease: 'loader2'
        });

      });

    });

  }



  // Remove responsive image feature from CS pages

  const imgs = document.getElementsByTagName('img');

  for (let i = 0; i < imgs.length; i++) {

    imgs[i].removeAttribute('srcset');

    imgs[i].removeAttribute('sizes');

  }

};



window.csMaskAnimation = function() {
  let mm = gsap.matchMedia();
  mm.add("(min-width: 992px)", () => {
    const csImageMasks = document.querySelectorAll('.portfolio_item_image-mask');
    csImageMasks.forEach((mask, index) => {
      if (index === 0) return;
      gsap.from(mask, {
        width: '100%',
        duration: 0.7,
        ease: 'loader2',
        scrollTrigger: {
          trigger: mask,
          start: 'top 80%',
          toggleActions: 'play none none none'
        },
      });
    });
    return () => gsap.set('.portfolio_item_image-mask', { clearProps: "all" });
  });
}



// Update the scroll trigger on page load

window.updateScrollTrigger = function() {

  window.onload = function() {

    ScrollTrigger.update();

  };

}



// Blog post main image mask animation

window.blogPostMaskAnimation = function(e) {

  const blogHero = document.querySelector('#heroSection');

  const blogMaskAnimation = gsap.from('.post_main-mask-ract', {

    left: '0%',

    ease: 'loader2',

  });

  ScrollTrigger.create({

    animation: blogMaskAnimation,

    trigger: blogHero,

    start: 'top -5%',

    end: 'bottom 50%',

    scrub: 0.5,

  });

}



// Custom checkboxes

window.changeCheckboxLabelColor = function() {

  let checkboxInputs = document.querySelectorAll('.w-checkbox-input');



  let callback = function(mutationsList, observer) {

    for (let mutation of mutationsList) {

      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {

        let isChecked = mutation.target.classList.contains('w--redirected-checked');

        let siblingLabel = mutation.target.parentElement.querySelector('.form-checkbox_label');



        if (isChecked && siblingLabel && !siblingLabel.classList.contains('is-active')) {

          siblingLabel.classList.add('is-active');

        } else if (!isChecked && siblingLabel && siblingLabel.classList.contains('is-active')) {

          siblingLabel.classList.remove('is-active');

        }

      }

    }

  };

  checkboxInputs.forEach(function(checkboxInput) {

    let config = {
      attributes: true,
      attributeFilter: ['class']
    };

    let observer = new MutationObserver(callback);

    observer.observe(checkboxInput, config);

  });

}



// Contact modal open animation

window.openContactModal = function() {

  contactFormOpen.play();

  document.body.classList.add('is-scroll-off');

  lenis.stop();

}



// Contact modal close animation

window.closeContactModal = function() {

  contactFormOpen.timeScale(1).reverse();

  document.body.classList.remove('is-scroll-off');

  lenis.start();

}



// Close contact modal on ESC click

window.closeContactModalOnEsc = function(e) {

  document.addEventListener('keydown', function(event) {

    if (event.key === "Escape") {

      window.closeContactModal();

    }

  });

}



// Form animation

// Hero animation on load

window.successMsgAnimation = function(e) {

  const successMsgAnim = gsap.timeline({}),



    homeHeroHeading = new SplitText('#successHoooray, #successHeadiline', {

      type: 'lines',

      linesClass: 'hero-line',

    }),

    homeHeroHeadingMask = new SplitText('#successHoooray, #successHeadiline', {

      type: 'lines',

      linesClass: 'hero-line-mask',

    });

  successMsgAnim.from(

    '.hero-line',

    {

      duration: 1.2,

      y: '100%',

      stagger: 0.2,

      ease: 'loader2',

    }

  );

  successMsgAnim.to(

    e,

    {

      width: '0%',

      duration: 0.6,

      ease: 'loader2',

    },

    '>-0.5'

  );

  successMsgAnim.from(

    '#successParagraph',

    {

      opacity: 0,

      duration: 0.3,

      ease: 'loader2',

    },

    '>-0.4'

  );

}



// Form animation on submit

window.formSubmitAnimation = function(e) {

  function observeDisplayChanges() {

    const targetElement = document.querySelector('.contact-modal_form-success');

    const observerConfig = {

      attributes: true,

      attributeFilter: ['style'],

    };

    const observer = new MutationObserver(function(mutationsList, observer) {

      mutationsList.forEach(function(mutation) {

        if (mutation.target.style.display === 'block') {

          successMsgAnimation(e);

        }

      });

    });

    observer.observe(targetElement, observerConfig);

  }

  observeDisplayChanges();

}



window.initBentoRevealScrub = function(container) {

  // 1. Warunek szerokości - tylko powyżej 992px

  if (window.innerWidth < 992) {

    // Na mobilkach wymuszamy widoczność, żeby nie było dziur

    container.querySelectorAll(':scope > *').forEach(el => {

      gsap.set(el, {
        opacity: 1,
        y: 0
      });

    });

    return;

  }



  // 2. Respect reduced motion

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {

    container.querySelectorAll(':scope > *').forEach(el => {

      el.style.opacity = 1;

      el.style.transform = 'none';

    });

    return;

  }



  const items = Array.from(container.children);



  // 3. Używamy matchMedia, żeby GSAP sam pilnował szerokości okna

  let mm = gsap.matchMedia();



  mm.add("(min-width: 992px)", () => {

    const tl = gsap.timeline({

      scrollTrigger: {

        trigger: container,

        start: 'top 90%',

        end: 'bottom 65%',

        scrub: 0.5,

        markers: false,

        invalidateOnRefresh: true, // Kluczowe przy zmianie rozmiaru okna

      }

    });



    tl.fromTo(items,

      {
        opacity: 0,
        y: 28
      },

      {

        opacity: 1,

        y: 0,

        ease: 'power2.out',

        stagger: {
          each: 0.12
        }

      }

    );



    // Sprzątanie przy wyjściu z breakpointu

    return () => {

      gsap.set(items, {
        clearProps: "all"
      });

    };

  });

};



// Refresh Gsap scrollTriggers

window.scrollTriggerRefresh = function() {

  function refreshScrollTrigger() {

    ScrollTrigger.refresh();

  }

  const observer = new MutationObserver(refreshScrollTrigger);

  const targetNode = document.querySelector('.section.is-post-body');

  const config = {
    attributes: true,
    childList: true,
    subtree: true
  };

  observer.observe(targetNode, config);

}



// Info bar close animation

window.closeInfoBar = function() {

  const infoBarClose = gsap.timeline({});

  infoBarClose.to('.info-bar', {

    height: 0,

    autoAlpha: 0,

    duration: 0.3,

    ease: 'loader2',

  });

  infoBarClose.to('.button_small.is-navbar', {

    top: "1.75rem",

    duration: 0.3,

    ease: 'loader2',

  }, "<");

  infoBarClose.to('#heroSection', {

    paddingTop: "6.5rem",

    duration: 0.3,

    ease: 'loader2',

  }, "<");



}




// Hero 2026 animation - navbar letters on scroll

window.heroAnimation2026 = function(e) {

  const wideletters = document.querySelectorAll('.wideletter');

  if (wideletters.length === 0) return;



  // Timeline for letters OUT

  const lettersOutTimeline = gsap.timeline({
    paused: true
  });

  lettersOutTimeline.fromTo(wideletters,

    {
      y: '0%',
      opacity: 1
    },

    {

      y: '-150%',

      opacity: 0,

      duration: 0.6,

      ease: 'power2.in',

      stagger: 0.03,

    }

  );



  // Trigger: .update26 top reaches 80% viewport → letters OUT, scroll back → reverse

  const update26 = document.querySelector('.update26');

  if (!update26) return;



  ScrollTrigger.create({

    trigger: update26,

    start: 'top 80%',

    onEnter: () => lettersOutTimeline.play(),

    onLeaveBack: () => lettersOutTimeline.reverse(),

  });

};




window.CaseHeroAnimation = function(e) {

  const wideletters = document.querySelectorAll('.wideletter');

  const isCshero = document.querySelector('.is-cshero');

  const firstAfterSticky = document.querySelector('.first-after-sticky');



  let mm = gsap.matchMedia();



  mm.add("(min-width: 992px)", () => {

    // --- LOGIKA TYLKO DLA DESKTOP ---



    // Page load animation timeline (starts after 200ms)

    const pageLoadTimeline = gsap.timeline({
      delay: 0.2
    });



    // 1. .wideletter IN

    if (wideletters.length > 0) {

      pageLoadTimeline.fromTo(wideletters,

        {
          y: '-150%',
          opacity: 0
        },

        {
          y: '0%',
          opacity: 1,
          duration: 1.2,
          ease: 'loader',
          stagger: 0.1
        },

        0

      );

    }



    // 2. .navbar i przyciski

    const navbar = document.querySelector('.navbar');

    const navButtons = document.querySelectorAll('.button_small.is-navbar');

    if (navbar || navButtons.length > 0) {

      const navbarElements = navbar ? [navbar, ...Array.from(navButtons)] : Array.from(navButtons);

      pageLoadTimeline.from(navbarElements, {

        y: '-100%',

        duration: 1.2,

        ease: 'loader',

        stagger: 0.15,

      }, 0);

    }



    // 3. .hero_headline (SplitText)

    const heroHeadline = document.querySelector('.hero_headline');

    if (heroHeadline) {

      new SplitText(heroHeadline, {
        type: 'lines',
        linesClass: 'gsap-title-line'
      });

      new SplitText(heroHeadline, {
        type: 'lines',
        linesClass: 'gsap-title-line-mask'
      });

      const heroLines = heroHeadline.querySelectorAll('.gsap-title-line');

      if (heroLines.length > 0) {

        gsap.set(heroLines, {
          y: '100%',
          opacity: 0
        });

        pageLoadTimeline.to(heroLines, {

          y: '0%',

          duration: 1,

          opacity: 1,

          stagger: 0.15,

          ease: 'loader',

        }, 0.2);

      }

    }



    // 4. .cs-tags

    const csTags = document.querySelector('.cs-tags');

    if (csTags && csTags.children.length > 0) {

      pageLoadTimeline.from(Array.from(csTags.children), {

        y: '100%',

        opacity: 0,

        duration: 1.2,

        ease: 'loader',

        stagger: 0.15,

      }, 0.4);

    }



    // Timelines dla scrolla (OUT / IN)

    const lettersOutTimeline = gsap.timeline({
      paused: true
    });

    if (wideletters.length > 0) {

      lettersOutTimeline.fromTo(wideletters, {
        y: '0%',
        opacity: 1
      }, {

        y: '-150%',
        opacity: 0,
        duration: 0.6,
        ease: 'power2.in',
        stagger: 0.03

      });

    }

    if (isCshero) {

      lettersOutTimeline.to(isCshero, {
        opacity: 0,
        duration: 0.6,
        ease: 'power2.in'
      }, 0);

    }



    const lettersInTimeline = gsap.timeline({
      paused: true
    });

    if (wideletters.length > 0) {

      lettersInTimeline.fromTo(wideletters, {
        y: '-150%',
        opacity: 0
      }, {

        y: '0%',
        opacity: 1,
        duration: 1,
        ease: 'loader2',
        stagger: 0.1

      });

    }



    // ScrollTrigger

    let scrollTriggerActive = false;

    let st;

    if (firstAfterSticky) {

      st = ScrollTrigger.create({

        trigger: firstAfterSticky,

        start: 'top 80%',

        end: 'top top',

        onEnter: () => {
          scrollTriggerActive = true;
          lettersOutTimeline.play();
        },

        onLeaveBack: () => {
          scrollTriggerActive = false;
          lettersOutTimeline.reverse();
        }

      });

    }



    // Global scroll listener (zabezpieczony)

    let lastScrollY = window.scrollY;

    let pageLoadComplete = false;

    pageLoadTimeline.eventCallback('onComplete', () => {
      pageLoadComplete = true;
    });



    const handleScroll = () => {

      if (!pageLoadComplete || scrollTriggerActive) return;

      const currentScrollY = window.scrollY;

      if (currentScrollY < lastScrollY && wideletters.length > 0) {

        lettersInTimeline.play();

      }

      lastScrollY = currentScrollY;

    };



    window.addEventListener('scroll', handleScroll);



    // CLEANUP - sprzątanie przy zmianie na Mobile

    return () => {

      window.removeEventListener('scroll', handleScroll);

      if (st) st.kill();

      gsap.set([wideletters, isCshero, '.navbar', '.button_small.is-navbar', '.gsap-title-line', '.cs-tags > *'], {
        clearProps: "all"
      });

    };

  });



  // --- REAKCJA DLA MOBILE (< 992px) ---

  if (window.innerWidth < 992) {

    // Wymuszamy widoczność, żeby uniknąć initial state (opacity 0) na iPhone

    gsap.set([wideletters, isCshero, '.hero_headline', '.cs-tags > *'], {
      opacity: 1,
      y: '0%',
      visibility: 'visible'
    });

  }

};




// Intro animation on page load

window.introAnimation = function(e) {

  const introBrand = e.querySelector('[intro-brand]');

  const introSubtitle = e.querySelector('[intro-subtitle]');

  const widelettersIntro = e.querySelectorAll('.wideletter-intro');



  // Set initial states

  gsap.set([introBrand, introSubtitle], {
    opacity: 0
  });

  gsap.set(widelettersIntro, {
    y: '-150%'
  });



  // Prevent browser scroll restoration and force scroll to top

  history.scrollRestoration = 'manual';

  window.scrollTo(0, 0);



  // Lock scroll: position fixed keeps scrollbar visible but prevents scrolling

  document.body.style.position = 'fixed';

  document.body.style.top = '0px';

  document.body.style.width = '100%';



  // Page load animation - scroll timeline is created AFTER this completes

  const introTimeline = gsap.timeline({

    onComplete: () => {

      // Unlock scroll

      document.body.style.position = '';

      document.body.style.top = '';

      document.body.style.width = '';

      window.scrollTo(0, 0);



      // Force all letters to final state before creating ScrollTrigger

      gsap.set(widelettersIntro, {
        y: '0%',
        opacity: 1
      });

      gsap.set(introBrand, {
        opacity: 1
      });



      // Small delay to ensure DOM is ready, then create scroll timeline and refresh ScrollTrigger

      requestAnimationFrame(() => {

        createScrollTimeline();

        ScrollTrigger.refresh();

      });

    }

  });



  introTimeline.to(introBrand, {

    opacity: 1,

    duration: 0.1,

  });



  introTimeline.to(widelettersIntro, {

    y: '0%',

    duration: 1,

    ease: 'loader2',

    stagger: 0.1,

  });



  // EXPERIMENTAL: play/reverse version (no parallax)

  function createScrollTimeline() {

    // Timeline 1: Letters out

    const lettersOutTimeline = gsap.timeline({
      paused: true
    });

    lettersOutTimeline.to(widelettersIntro, {

      y: '-150%',

      opacity: 0,

      duration: 0.6,

      ease: 'power2.in',

      stagger: 0.03,

    });



    // Trigger 1: Letters out (at 20% of section)

    ScrollTrigger.create({

      trigger: e,

      start: 'top top-=20%',

      onEnter: () => lettersOutTimeline.play(),

      onLeaveBack: () => lettersOutTimeline.reverse(),

    });



    // Timeline 2: Subtitle in

    const subtitleInTimeline = gsap.timeline({
      paused: true
    });

    subtitleInTimeline.fromTo(introSubtitle,

      {
        y: '50%',
        opacity: 0
      },

      {
        y: '0%',
        opacity: 1,
        duration: 0.6,
        ease: 'power2.out'
      }

    );



    // Trigger 2: Subtitle in (at 90% of section)

    ScrollTrigger.create({

      trigger: e,

      start: 'top top-=90%',

      onEnter: () => subtitleInTimeline.play(),

      onLeaveBack: () => subtitleInTimeline.reverse(),

    });



    // Timeline 3: Subtitle out

    const subtitleOutTimeline = gsap.timeline({
      paused: true
    });

    subtitleOutTimeline.to(introSubtitle, {

      opacity: 0,

      duration: 0.5,

      ease: 'power2.out',

    });



    // Trigger 3: Subtitle out (at 140% - well into section scroll)

    ScrollTrigger.create({

      trigger: e,

      start: 'top top-=140%',

      onEnter: () => subtitleOutTimeline.play(),

      onLeaveBack: () => subtitleOutTimeline.reverse(),

    });

  }

};


function gsapTitleAnimation() {
  if (!window.isPageUnlocked) return;
  let mm = gsap.matchMedia();
  mm.add("(min-width: 992px)", () => {
    const gsapTitles = document.querySelectorAll('[gsap-title]');
    gsapTitles.forEach((titleElement) => {
      new SplitText(titleElement, { type: 'lines', linesClass: 'gsap-title-line' });
      new SplitText(titleElement, { type: 'lines', linesClass: 'gsap-title-line-mask' });
      const lines = titleElement.querySelectorAll('.gsap-title-line');
      if (lines.length === 0) return;

      gsap.set(lines, { y: '1.25rem', opacity: 0 });
      gsap.to(lines, {
        y: '0rem', opacity: 1, duration: 0.75, stagger: 0.15, ease: 'loader2',
        scrollTrigger: {
          trigger: titleElement,
          start: 'top 90%',
          toggleActions: 'play none none none',
        }
      });
    });
    return () => gsap.set('[gsap-title] .gsap-title-line', { clearProps: "all" });
  });
}

function gsapContainerAnimation() {
  if (!window.isPageUnlocked) return;
  let mm = gsap.matchMedia();
  mm.add("(min-width: 992px)", () => {
    const gsapContainers = document.querySelectorAll('[gsap-container]');
    gsapContainers.forEach((container) => {
      const children = container.children;
      if (children.length === 0) return;

      gsap.set(children, { y: '4rem', opacity: 0 });
      gsap.to(children, {
        y: '0rem', opacity: 1, duration: 1, stagger: 0.1, ease: 'power3.out',
        scrollTrigger: {
          trigger: container,
          start: 'top 90%',
          toggleActions: 'play none none none',
        }
      });
    });
    return () => gsap.set('[gsap-container] > *', { clearProps: "all" });
  });
}


function gsapFadeAnimation() {
  if (!window.isPageUnlocked) return;
  let mm = gsap.matchMedia();
  mm.add("(min-width: 992px)", () => {
    const gsapFadeElements = document.querySelectorAll('[gsap-fade]');
    gsapFadeElements.forEach((element) => {
      gsap.set(element, { opacity: 0 });
      gsap.to(element, {
        opacity: 1, duration: 2, ease: 'power3.out',
        scrollTrigger: {
          trigger: element,
          start: 'top 85%',
          toggleActions: 'play none none none',
        }
      });
    });
    return () => gsap.set('[gsap-fade]', { clearProps: "all" });
  });
}



// !!!!!!!!! Keep this Alpine init at the end !!!!!!!!!

window.Webflow ||= [];

window.Webflow.push(() => {

  initAlpine();

  lazyLoadVideos();



  if (Webflow.env("editor") === undefined) {

    lenisScroll();

    if (typeof lenis.start === 'function') lenis.start();

  }



  customGsapEasing();

  reloadOnBack();

  revealFooter();

  initStickyNavbarAnimation();

  pageLoadAnimation(); // To wywoła initBasicAnimations, które też trzeba poprawić

  pageTransitionAnimation();

  customCursorOnClick();

  contactFormOpenAnimation();

  openContactFormFromURL();

  disableScrollMenu();



  // UWAGA: Usunięto stąd inicjalizację tytułów. Czekamy na unlockScroll.

});